import { render, staticRenderFns } from "./LandGHomeCard.vue?vue&type=template&id=404d7586"
import script from "./LandGHomeCard.vue?vue&type=script&lang=js"
export * from "./LandGHomeCard.vue?vue&type=script&lang=js"
import style0 from "./LandGHomeCard.vue?vue&type=style&index=0&id=404d7586&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports